export default {
  clientId: 'ID do Cliente',
  reviewedSummaries: 'Resumos Revisados',
  summaryId: 'ID do Resumo',
  user: 'Usuário',
  vote: 'Voto',
  comment: 'Comentário',
  timestamp: 'Data e hora'
}
